import { createApiRequest } from "@/lib/api/createApiService";
import { NOTIFICATION_ENDPOINTS } from "./notifications.endpoints";

export const notificationsService = {
  listNotifications: async ({ limit = 100 } = {}, options = {}) => {
    return createApiRequest({
      url: NOTIFICATION_ENDPOINTS.LIST,
      method: "GET",
      body: { limit },
      ...options,
    });
  },

  markRead: async (id, options = {}) => {
    return createApiRequest({
      url: NOTIFICATION_ENDPOINTS.MARK_READ(id),
      method: "POST",
      body: {},
      ...options,
    });
  },

  markAllRead: async (options = {}) => {
    return createApiRequest({
      url: NOTIFICATION_ENDPOINTS.MARK_ALL_READ,
      method: "POST",
      body: {},
      ...options,
    });
  },

  remove: async (id, options = {}) => {
    return createApiRequest({
      url: NOTIFICATION_ENDPOINTS.DELETE(id),
      method: "DELETE",
      ...options,
    });
  },

  clearAll: async (options = {}) => {
    return createApiRequest({
      url: NOTIFICATION_ENDPOINTS.CLEAR,
      method: "DELETE",
      ...options,
    });
  },
};
